// extracted by mini-css-extract-plugin
export default {"item":"TodoItem_item__DbVYA","checkbox":"TodoItem_checkbox__iVKmx","textInput":"TodoItem_textInput__wmdOv"};